import * as React from 'react';
import './Paypal.less';
import { functionsURL } from '../../firebase';
import {
  PARTNER_REFERRAL_RETURN_URL,
} from '../../paypal';

interface PaypalButtonProps {
  /**
   * The user logged into the dashboard
   */
  auth: any;

  /**
   * true if the charity PayPal account has been onboarded
   */
  is_connect: boolean;

  /**
   * function to trigger disconnection of the charity PayPal account
   */
  onDisconnectPaypal: () => void;

  /**
   * true if we are retrieving the current PayPal onboarding status
   */
  isLoading: boolean;

  /**
   * true if the button is showing the confirm disconnect state
   */
  confirm: boolean;

  /**
   * Callback to enable/disable confirm disconnect state
   */
  setConfirmDisconnect: (e: any, mode: '' | 'paypal') => void;
}

class PaypalButton extends React.Component<PaypalButtonProps> {

  onDisconnectPaypalaccount = () => {
    const { onDisconnectPaypal } = this.props;
    if (onDisconnectPaypal) {
      onDisconnectPaypal();
    }
    this.props.setConfirmDisconnect(null, '');
  }

  render() {
    const { auth, is_connect, isLoading, confirm } = this.props;
    const createPayPalReferralURL = `${functionsURL}/create-referral?authid=${
      auth.uid
    }&charityid=${
      auth.charityKey
    }&return_url=${
      PARTNER_REFERRAL_RETURN_URL
    }`;
    // disable if we are loading or there's no onboarding URL
    const isDisabled = isLoading || !createPayPalReferralURL;
    return (
      <div className={'wrap-button-paypal' + (isLoading ? ' loading' : '') + (confirm ? ' confirm' : '')}>
        {is_connect ? (
          <a
            className="btn btn-primary"
            onClick={confirm ? () => this.onDisconnectPaypalaccount() : (e) => this.props.setConfirmDisconnect(e, 'paypal')}
          >
            <span>{confirm ? 'Confirm Disconnect' : 'Disconnect From PayPal'}</span>
          </a>
        ) : (
          <a
            className={isDisabled ? 'isDisabled' : ''}
            data-paypal-button="true"
            href={createPayPalReferralURL}
            target="PPMiniWin"
          >
            Connect With PayPal
          </a>
        )}
      </div>
    );
  }
}

export default PaypalButton;
